module.exports = __webpack_public_path__ + "images/gameMain-di_018.png?685a24b4c5224e09cdceadfd0c1b0ea8";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameMain-di_018.png
// module id = 169
// module chunks = 0